import React from 'react';
import './Services.scss';
import interior from '../assests/interior.jpeg';
import exterior from '../assests/exteriors.png';
import cabs from '../assests/cabs.jpeg';
import strata from '../assests/strata.jpg';
import { scrollToSection } from '../components/Header';
import { Building, Cabinet, Home, Roller } from '../components/Icons';

const services = [
  {
    title: 'Interior Painting',
    text: 'Walls, ceilings, trim and feature walls, matched to your style. Clean lines, premium products and a tidy crew.',
    img: interior,
    icon: <Roller />,
  },
  {
    title: 'Exterior Painting',
    text: 'Durable coastal finishes for siding, stucco, trim and decks that stand up to Lower Mainland weather.',
    img: exterior,
    icon: <Home />,
  },
  {
    title: 'Strata & Commercial',
    text: 'Townhomes, condo buildings, offices, retail and warehouses. We scale the crew to the building.',
    img: strata,
    icon: <Building />,
  },
  {
    title: 'Cabinets & Specialty',
    text: 'Kitchen cabinet refinishing, staining for decks and fences, and other specialty surfaces done right.',
    img: cabs,
    icon: <Cabinet />,
  },
];

const chips = [
  'Interior Painting',
  'Exterior Painting',
  'Kitchen Cabinets',
  'Strata Painting',
  'Commercial Painting',
  'Warehouse & Industrial',
  'Staining',
  'Licensed & Insured',
];

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Services() {
  return (
    <section id="services" className="section services">
      <div className="container">
        <div className="head">
          <span className="eyebrow reveal">Our services</span>
          <h2 className="reveal" style={d(80)}>
            The Right Finish
            <br />
            for Every Property.
          </h2>
          <p className="lede reveal" style={d(160)}>
            From a single feature wall to a full strata exterior or warehouse interior, we bring the same care,
            precision and clean-up to every job.
          </p>
        </div>

        <div className="services__grid">
          {services.map((s, i) => (
            <button key={s.title} className="svc reveal" style={d(i * 90)} onClick={() => scrollToSection('contact')} aria-label={`Book ${s.title}`}>
              <img src={s.img} alt="" loading="lazy" />
              <span className="svc__body">
                <span className="svc__icon">{s.icon}</span>
                <span className="svc__title">{s.title}</span>
                <span className="svc__text">{s.text}</span>
              </span>
            </button>
          ))}
        </div>

        <ul className="services__chips reveal" style={d(200)}>
          {chips.map((c) => (
            <li key={c}>{c}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
